import { Fragment } from 'react';
import { useQuery } from '@apollo/client/react';
import { t, select } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Button, Dialog, DialogHeader, DialogContent, DialogFooter, TextInput, DialogLoading, DialogError, Box, } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { Field, Form, useFormikContext } from 'formik';
import { ROOT } from 'app/domains/filesystem/utils/constants';
import { CancelButton, SubmitButton } from 'shared/domains/forms';
import { DocumentOptions } from './DocumentOptions';
import { FileSystemDialogDocument } from './FileSystemDialog.gql';
import { AccessManagementList } from '../../AccessManagement/AccessManagementList';
import { AccessManagementOwners } from '../../AccessManagement/AccessManagementOwners';
import { AccessManagementSearch } from '../../AccessManagement/AccessManagementSearch';
import SelectFolderField from '../SelectFolderField';
import { FieldContainer } from './styled';
export function FileSystemDialog(props) {
    const { selectedId, entryType, onDiscard, onClose } = props;
    const { data, error, loading, refetch } = useQuery(FileSystemDialogDocument, {
        variables: {
            withParentId: Boolean(selectedId),
            parentId: selectedId || ROOT,
        },
    });
    const { selectedFolder } = data || {};
    const { isSubmitting } = useFormikContext();
    const title = select(entryType, {
        FOLDER: 'Save folder',
        DOCUMENT: 'Save file',
        other: 'Save',
    });
    if (loading) {
        return (<Dialog>
        <DialogLoading />
      </Dialog>);
    }
    if (error) {
        return (<Dialog>
        <DialogError title={t({ message: 'Error', comment: 'Filesystem dialog error title' })} description={t({
                message: 'Something went wrong while loading the dialog, please try again.',
                comment: 'Filesystem dialog error message',
            })} actions={<Fragment>
              <Button type="button" appearance="secondary" size="small" onClick={onClose}>
                <Trans comment="Filesystem dialog error">Close</Trans>
              </Button>
              <Button type="button" size="small" onClick={() => refetch()}>
                <Trans comment="Filesystem dialog error">Try again</Trans>
              </Button>
            </Fragment>}/>
      </Dialog>);
    }
    return (<Dialog as={Form} onClose={isSubmitting ? undefined : onClose}>
      <DialogHeader icon={<Falcon icon="folder"/>} title={title}/>
      <DialogContent>
        <FieldContainer>
          <Field name="name" as={TextInput} label={t `Name`} disabled={isSubmitting} stretch/>
        </FieldContainer>

        {entryType !== 'DOCUMENT' && (<FieldContainer>
            <SelectFolderField folder={selectedFolder}/>
          </FieldContainer>)}

        {entryType === 'DOCUMENT' && (<FieldContainer>
            <DocumentOptions folder={selectedFolder}/>
          </FieldContainer>)}

        <FieldContainer>
          <Box gap="md" flexDirection="column">
            <AccessManagementSearch from={data || {}} fromParentEntry={selectedFolder || {}}/>
            <AccessManagementOwners from={data || {}}/>
            <AccessManagementList parentId={selectedId}/>
          </Box>
        </FieldContainer>
      </DialogContent>
      <DialogFooter description={onDiscard && (<Button type="button" appearance="secondary" onClick={onDiscard} disabled={isSubmitting}>
              <Trans>Continue without saving</Trans>
            </Button>)}>
        <CancelButton onClick={onClose}>
          <Trans>Cancel</Trans>
        </CancelButton>
        <SubmitButton>
          <Trans>Save</Trans>
        </SubmitButton>
      </DialogFooter>
    </Dialog>);
}
